import React from 'react';
import PropTypes from 'prop-types';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import PartnerStudentVariationGauge from './PartnerStudentVariationGauge';
import CustomerSuccessHistoryService from '../../services/CustomerSuccessHistoryService';
import { PartnerStudentVariationListService } from '../../services/CustomerSuccessKpiListService';

class PartnerStudentVariationCompanyGaugeContainer extends React.Component {
  static propTypes = {
    companyId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    PartnerStudentVariationListService.load();
  }

  render() {
    const data = toJS(PartnerStudentVariationListService.getByCompanyId(this.props.companyId));
    return (
      <PartnerStudentVariationGauge
        loading={
          PartnerStudentVariationListService.fetchCurrent.fetching ||
          PartnerStudentVariationListService.fetchPrevious.fetching
        }
        currentValue={data.current}
        previousValue={data.previous}
        onClickHistory={() =>
          CustomerSuccessHistoryService.openDialog('PARTNER_STUDENT_VARIATION', this.props.companyId)
        }
        formatter={PartnerStudentVariationListService.getFormattedValue}
      />
    );
  }
}

export default observer(PartnerStudentVariationCompanyGaugeContainer);
